import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output
} from '@angular/core';


@Component({
    selector: 'ppl-email-verification-verification-complete',
    templateUrl: './email-verification-verification-complete.component.html',
    styleUrl: './email-verification-verification-complete.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailVerificationVerificationCompleteComponent {
  @Output() login = new EventEmitter();

  onLogin() {
    this.login.emit();
  }
}
